import React, {createContext, ReactNode, useContext} from 'react';
import {CmCollection, PageGridPlacement as CmPageGridPlacement} from "../../packages/graphql-layer/src";
import {placement_header} from "../components/page_layouts/pageLayoutsUtils";

interface PageContextType {
    page: any,
    siteId: string,
    taxonomies: string[],
    rootUrl: string,
    searchEnabled: boolean,
    hideTopNavi: boolean
}

interface Props {
    children: ReactNode
    page: any
    siteId: string
    rootUrl: string
    taxonomies: string[]
}

export const PageContext = createContext<PageContextType>({} as PageContextType);
const usePageContext = () => useContext(PageContext)

const PageProvider = (props: Props) => {
    const searchEnabled = props.page?.searchSettings?.["searchEnabled"] || false;
    const header = props.page?.grid.placements.find((p: CmPageGridPlacement) => p.name === placement_header);
    const topNavi = header?.items?.find((cmCol: CmCollection) => cmCol.viewtype === "asTopNavi") as CmCollection;
    const topNaviItems = topNavi?.items ?? [];
    const hideTopNavi = topNaviItems.length === 0 && !searchEnabled;
    
    return (
        <PageContext.Provider
            value={{page: props.page,
                siteId: props.siteId,
                rootUrl: props.rootUrl,
                taxonomies: props.taxonomies,
                searchEnabled: searchEnabled,
                hideTopNavi: hideTopNavi
            }}>
            {props.children}
        </PageContext.Provider>
    );
}

export {
    usePageContext,
    PageProvider
}
